import { useContext } from 'react';
import { TalentPortalTabsContext } from './talent-portal-tabs.context';

const useTalentPortalTabsContext = () => useContext(TalentPortalTabsContext);

export default useTalentPortalTabsContext;
